export const Availability = {
  AvailableNow: 1,
  Available: 2,
  Preorder: 3,
  SoldOut: 4,
  Trunkshow: 5
};
